import React, { useState } from "react";
import cn from "classnames";
import Icon from "./Icon";

const Export = ({ logged, openAuth, onExport = () => { } }) => {
  const [visible, setVisible] = useState(false);

  const handleClick = type => {
    onExport(type);
    setVisible(false);
  }

  return (
    <div className={cn("export",
      { open: visible },
      { logged: logged }
    )}>
      <div className="export__container"
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}>
        {logged ?
          <>
            <div className="export__head">
              <div className="export__title">Export</div>
              <Icon.Down className="export__arrow" />
            </div>
            <div className="export__dropdown">
              {["svg", "png"].map((x, index) =>
                <button className="export__action"
                  onClick={() => handleClick(x)}
                  key={index}>{x}</button>
              )}
            </div>
          </> :
          <button className="export__head" onClick={openAuth}>
            <div className="export__title">Export</div>
            <Icon.Down className="export__arrow" />
          </button>
        }
      </div>
    </div>
  );
};

export default Export;
